import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';

import { Col, Row, Card, CardBody, Button, Spinner, Modal, ModalBody, ModalHeader, ModalFooter, Alert, Input, Form, FormGroup, Label } from 'reactstrap';

class PaymentsTable extends Component {
  static propTypes = {
    user: PropTypes.shape(),
    fetchStripeLoginLink: PropTypes.func.isRequired,
    getStripeCompanyStatus: PropTypes.func.isRequired,
    addStripeAccount: PropTypes.func.isRequired,
    getSinglePayment: PropTypes.func.isRequired,
    fetchPaymentTooltips: PropTypes.func.isRequired,
    resendEmail: PropTypes.func.isRequired,
    fetchLinkedAPIs: PropTypes.func.isRequired,
    checkCompStatus: PropTypes.func.isRequired,
    openCodePreview: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: {},
  };

  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };
  }

  componentDidMount() {

  }

  render() {
    const {
      dontShowPage,
      resendEmailProcessing,
      phoneCode,
      reAuthError,
      reAuthPassword,
      reAuthSpinner,
      openReAuthModal,
      confirmRedeemModalOpen,
      confirmRedeemModalError,
      confirmModalOpen,
      confirmModalError,
      resendEmailOpen,
      resendEmailError,
      resendEmailValue,
      redeemModalProcessing,
      confirmModalProcessing,
      processingSend2fa,
      show2faModal,

      closeConfirmRedeemModal,
      finishConfirmRedeemModal,
      closeConfirmModal,
      finishConfirmModal,
      closeResendEmail,
      handleChange,
      resendEmail,
      closeReAuthModal,
      reAuthenticate,
      close2faModal,
      handleCodeChange2,
      digit1,
      digit2,
      digit3,
      digit4,
      digit5, 
      digit6,
      submitVerificationCode,
    } = this.props;

    if (dontShowPage) {
      return (
        <div>
          <Card>
            <CardBody>
              You don't have permissions to view payments
            </CardBody>
          </Card>
        </div>
      );
    }

    return (
      <>
        <Modal isOpen={confirmRedeemModalOpen} toggle={closeConfirmRedeemModal}>
          <ModalBody toggle={closeConfirmRedeemModal}>
              <Row>
                <Col xs="12">
                  {(!!confirmRedeemModalError) && <Alert color="danger">{`Failed to finish action - ${confirmRedeemModalError}`}</Alert>}
                </Col>
              </Row>
              <Row>
                <Col xs="6">
                  Are you sure?
                </Col>
                <Col xs="6">
                  <Button color="secondary" style={{ boxShadow: 'none', float: 'right' }} onClick={closeConfirmRedeemModal}>No</Button>
                  <Button color="primary" style={{ float: 'right', marginRight: 8 }} className="custom-modal-button" onClick={finishConfirmRedeemModal}>
                    Yes
                    {(redeemModalProcessing) ? (
                      <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                    ) : (null)}
                  </Button>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
          <Modal isOpen={confirmModalOpen} toggle={closeConfirmModal}>
          <ModalBody toggle={closeConfirmModal}>
              <Row>
                <Col xs="12">
                  {(!!confirmModalError) && <Alert color="danger">{`Failed to finish action - ${confirmModalError}`}</Alert>}
                </Col>
              </Row>
              <Row>
                <Col xs="6">
                  Are you sure?
                </Col>
                <Col xs="6">
                  <Button color="secondary" style={{ float: 'right' }} onClick={closeConfirmModal}>No</Button>
                  <Button color="primary" style={{ float: 'right', marginRight: 8 }} className="custom-modal-button" onClick={finishConfirmModal}>
                    Yes
                    {(confirmModalProcessing) ? (
                      <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                    ) : (null)}
                  </Button>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
          <Modal isOpen={resendEmailOpen} toggle={closeResendEmail}>
            <ModalBody toggle={closeResendEmail}>
              <Row>
                <Col xs="12">
                  {(!!resendEmailError) && <Alert color="danger">{`Failed to finish action - ${resendEmailError}`}</Alert>}
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <Input
                    type="text"
                    name="resendEmailValue"
                    id="resendEmailValue"
                    value={resendEmailValue}
                    onChange={handleChange} />
                </Col>
                <Col xs="12">
                  <Button color="secondary" style={{ boxShadow: 'none', float: 'right' }} onClick={closeResendEmail}>Close</Button>
                  <Button color="primary" style={{ float: 'right', marginRight: 8 }} className="custom-modal-button" onClick={resendEmail}>
                    Send
                    {(resendEmailProcessing) ? (
                      <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                    ) : (null)}
                  </Button>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
          <Modal isOpen={openReAuthModal} toggle={closeReAuthModal}>
            <ModalHeader> Re-enter password </ModalHeader>
          <ModalBody toggle={closeReAuthModal}>
              <Row>
                <Col xs="12">
                  {(!!reAuthError) && <Alert color="danger">{`Failed to authenticate`}</Alert>}
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <Input
                    type="password"
                    name="reAuthPassword"
                    id="reAuthPassword"
                    value={reAuthPassword}
                    onChange={handleChange} />
                </Col>
                <Col xs="12">
                  <Button color="primary" style={{ float: 'right', marginRight: 8, marginTop: 10 }} className="custom-modal-button" onClick={reAuthenticate}>
                    Confirm
                    {(reAuthSpinner) ? (
                      <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                    ) : (null)}
                  </Button>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
          <Modal isOpen={show2faModal} toggle={close2faModal} size="md">
            <ModalHeader toggle={close2faModal}>
              <div style={{ fontSize: 22 }}>Two-Factor Authentication</div>
            </ModalHeader>
            <ModalBody>
              <Form>
                <FormGroup>
                  <Label for="role">
                    For security, please enter your SMS verification code.
                  </Label>
                </FormGroup>
              </Form>
              <Row>
                <Col style={{ paddingLeft: '1vw', paddingRight: '1vw', minWidth: 37, width: 37 }}>
                  <Input
                    className="room-password-digit"
                    style={{ paddingLeft: '0.2em', paddingRight: '0.2em', textAlign: 'center', width: 37 }}
                    type="text"
                    name={0}
                    id="digit1"
                    value={phoneCode[0] || ''}
                    onChange={handleCodeChange2}
                    innerRef={digit1} />
                </Col>
                <Col style={{ paddingLeft: '1vw', paddingRight: '1vw', minWidth: 37, width: 37 }}>
                  <Input
                    style={{ paddingLeft: '0.2em', paddingRight: '0.2em', textAlign: 'center', width: 37 }}
                    type="text"
                    name={1}
                    id="digit2"
                    value={phoneCode[1] || ''}
                    onChange={handleCodeChange2}
                    innerRef={digit2} />
                </Col>
                <Col style={{ paddingLeft: '1vw', paddingRight: '1vw', minWidth: 37, width: 37 }}>
                  <Input
                    style={{ paddingLeft: '0.2em', paddingRight: '0.2em', textAlign: 'center', width: 37 }}
                    type="text"
                    name={2}
                    id="digit3"
                    value={phoneCode[2] || ''}
                    onChange={handleCodeChange2}
                    innerRef={digit3} />
                </Col>
                <Col style={{ paddingLeft: '1vw', paddingRight: '1vw', minWidth: 37, width: 37 }}>
                  <Input
                    style={{ paddingLeft: '0.2em', paddingRight: '0.2em', textAlign: 'center', width: 37 }}
                    type="text"
                    name={3}
                    id="digit4"
                    value={phoneCode[3] || ''}
                    onChange={handleCodeChange2}
                    innerRef={digit4} />
                </Col>
                <Col style={{ paddingLeft: '1vw', paddingRight: '1vw', minWidth: 37, width: 37 }}>
                  <Input
                    style={{ paddingLeft: '0.2em', paddingRight: '0.2em', textAlign: 'center', width: 37 }}
                    type="text"
                    name={4}
                    id="digit5"
                    value={phoneCode[4] || ''}
                    onChange={handleCodeChange2}
                    innerRef={digit5} />
                </Col>
                <Col style={{ paddingLeft: '1vw', paddingRight: '1vw', minWidth: 37, width: 37 }}>
                  <Input
                    style={{ paddingLeft: '0.2em', paddingRight: '0.2em', textAlign: 'center', width: 37 }}
                    type="text"
                    name={5}
                    id="digit6"
                    value={phoneCode[5] || ''}
                    onChange={handleCodeChange2}
                    innerRef={digit6} />
                </Col>
                <Col>
                  <Button color="primary" onClick={submitVerificationCode} style={{ float: 'right' }}>
                    Submit
                    {processingSend2fa ? (
                      <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem', marginTop: 3 }}> {''} </Spinner>
                    ) : (null)}
                  </Button>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>

            </ModalFooter>
          </Modal>
      </>
    );
  }
}

export default withRouter(PaymentsTable);
